const Config = {
  common: {
    privacy_cookies_url: "https://medicallogistics.co.uk/privacy-and-cookies-policy",
    terms_url: "https://medicallogistics.co.uk/terms-and-conditions",
    couriers_url: "https://bookcourier.medicallogistics.co.uk",
  },
};

export default Config;
